import React, { useState } from 'react';
import '../styles/Testimonials.css';

const Testimonials = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      location: 'Los Angeles, CA',
      service: 'General Pest Control',
      rating: 5,
      date: 'March 2026',
      image: 'https://randomuser.me/api/portraits/women/44.jpg',
      quote: 'PestControl Today saved us from a terrible ant infestation. They were professional, quick, and the price was fair. Highly recommend!',
      fullReview: 'We had ants everywhere in our kitchen and couldn\'t get rid of them. The team came out same day, identified the source, and treated the problem thoroughly. It\'s been 3 months and we haven\'t seen a single ant since. The technician was knowledgeable and took the time to explain everything. Absolutely worth every penny!',
      category: 'residential'
    },
    {
      id: 2,
      name: 'Michael Chen',
      location: 'New York, NY',
      service: 'Bed Bug Extermination',
      rating: 5,
      date: 'February 2026',
      image: 'https://randomuser.me/api/portraits/men/32.jpg',
      quote: 'After trying everything for bed bugs, these guys finally solved the problem. The team was knowledgeable and really cared about getting it right.',
      fullReview: 'We had a bed bug problem for months and tried multiple companies with no success. PestControl Today came in with their heat treatment and completely eliminated the infestation. They were professional, thorough, and followed up to make sure everything was okay. We can finally sleep peacefully again!',
      category: 'residential'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      location: 'Miami, FL',
      service: 'Eco-Friendly Treatment',
      rating: 5,
      date: 'January 2026',
      image: 'https://randomuser.me/api/portraits/women/63.jpg',
      quote: 'I\'ve used several pest control companies, but PestControl Today is by far the best. Their eco-friendly approach was perfect for my family.',
      fullReview: 'Being environmentally conscious, I was worried about using harsh chemicals. PestControl Today used eco-friendly products that were safe for my kids and pets. They did a fantastic job eliminating the roach problem and the results have lasted. I\'ll never use anyone else!',
      category: 'residential'
    },
    {
      id: 4,
      name: 'David Thompson',
      location: 'Chicago, IL',
      service: 'Termite Treatment',
      rating: 5,
      date: 'December 2025',
      image: 'https://randomuser.me/api/portraits/men/45.jpg',
      quote: 'Termites were destroying our deck. The team was professional, efficient, and completed the treatment on time. Great service!',
      fullReview: 'We found termites in our deck and were worried about the damage spreading to our house. PestControl Today came out for an inspection, provided a detailed treatment plan, and handled everything professionally. They were transparent about costs and the work was done perfectly. Our deck is now protected.',
      category: 'residential'
    },
    {
      id: 5,
      name: 'Lisa Martinez',
      location: 'Phoenix, AZ',
      service: 'Rodent Removal',
      rating: 4,
      date: 'November 2025',
      image: 'https://randomuser.me/api/portraits/women/17.jpg',
      quote: 'Had mice in the attic. The team was prompt, professional, and sealed all entry points. No more scratching sounds at night!',
      fullReview: 'We heard scratching in our attic at night and knew we had a rodent problem. PestControl Today came the next morning, set up traps, and sealed all entry points. Within a week, the problem was solved. They also gave us great advice on preventing future issues. Very satisfied with the service.',
      category: 'residential'
    },
    {
      id: 6,
      name: 'Robert Wilson',
      location: 'San Diego, CA',
      service: 'Commercial Services',
      rating: 5,
      date: 'October 2025',
      image: 'https://randomuser.me/api/portraits/men/22.jpg',
      quote: 'We run a restaurant and pest control is critical. PestControl Today provides reliable, discreet service that keeps us compliant.',
      fullReview: 'As a restaurant owner, maintaining a pest-free environment is essential for our business and health inspections. PestControl Today provides monthly service that is thorough, discreet, and never interrupts our operations. Our inspector has noticed the improvement and our rating has improved. Fantastic service!',
      category: 'commercial'
    }
  ];

  const filters = [
    { id: 'all', label: 'All Reviews' },
    { id: 'residential', label: 'Residential' },
    { id: 'commercial', label: 'Commercial' }
  ];

  const filteredTestimonials = activeFilter === 'all' 
    ? testimonials 
    : testimonials.filter(t => t.category === activeFilter);

  const averageRating = (testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length).toFixed(1);

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  const handleBookService = () => {
    window.location.href = 'tel:+18334936242';
  };

  return (
    <section className="test-section" id="testimonials">
      <div className="test-container">
        {/* Section Header */}
        <div className="test-header">
          <span className="test-tag">Testimonials</span>
          <h2 className="test-title">What Our Customers Say</h2>
          <p className="test-subtitle">
            Real reviews from real customers who trusted us with their pest problems
          </p>
        </div>

        {/* Rating Summary */}
        <div className="test-summary">
          <div className="test-rating-box">
            <div className="test-rating-number">{averageRating}</div>
            <div className="test-rating-stars">★★★★★</div>
            <div className="test-rating-count">Based on {testimonials.length} reviews</div>
          </div>
          <div className="test-rating-bars">
            {[5, 4, 3, 2, 1].map((star) => {
              const count = testimonials.filter(t => t.rating === star).length;
              const percentage = (count / testimonials.length) * 100;
              return (
                <div className="test-rating-bar" key={star}>
                  <span className="test-bar-label">{star} ★</span>
                  <div className="test-bar-track">
                    <div 
                      className="test-bar-fill" 
                      style={{ width: `${percentage}%` }}
                    ></div>
                  </div>
                  <span className="test-bar-count">{count}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="test-filters">
          {filters.map((filter) => (
            <button
              key={filter.id}
              className={`test-filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="test-grid">
          {filteredTestimonials.map((testimonial) => (
            <div className="test-card" key={testimonial.id}>
              <div className="test-card-header">
                <div className="test-user-info">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="test-user-image"
                    loading="lazy"
                  />
                  <div>
                    <h4 className="test-user-name">{testimonial.name}</h4>
                    <span className="test-user-location">{testimonial.location}</span>
                  </div>
                </div>
                <div className="test-rating">
                  <span className="test-stars">{renderStars(testimonial.rating)}</span>
                  <span className="test-date">{testimonial.date}</span>
                </div>
              </div>
              
              <div className="test-service-tag">{testimonial.service}</div>
              
              <p className="test-quote">"{testimonial.quote}"</p>
              
              <details className="test-read-more">
                <summary>Read Full Review</summary>
                <p>{testimonial.fullReview}</p>
              </details>
              
              <div className="test-verified">
                <span className="test-verified-icon">✓</span>
                Verified Customer
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="test-cta">
          <div className="test-cta-content">
            <h3>Ready to become our next happy customer?</h3>
            <p>Join thousands of satisfied customers across the USA</p>
          </div>
          <button className="test-cta-btn" onClick={handleBookService}>
            📞 Call Now: +1 (833) 493-6242 →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;